import { 
  EpDevPDocumentTypes, 
} from '../../constants';
import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import {
  IEpDevPListApplicationDomainsResponse,
  IEpDevPApplicationDomain,
  IEpDevPApplicationDomainsApiClient
} from '../types';
import { 
  EpDevPApplicationDomainsApiPathsFactory, 
} from './EpDevPApplicationDomainsApiFactories';

export class EpDevPApplicationDomainsApiClient extends EpDevPApiClient implements IEpDevPApplicationDomainsApiClient {

  public async listApplicationDomains({ organizationId }:{
    organizationId: string;
  }): Promise<IEpDevPListApplicationDomainsResponse> {
    const epDevPListApplicationDomainsResponse: IEpDevPListApplicationDomainsResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPApplicationDomainsApiPathsFactory.createListApplicationDomainsPath({ 
        organizationId: organizationId, 
      }))
    });
    return epDevPListApplicationDomainsResponse;
  }

  public async listCachedApplicationDomains({ organizationId, documentTypes }:{
    organizationId: string;
    documentTypes?: Array<EpDevPDocumentTypes>;
  }): Promise<IEpDevPListApplicationDomainsResponse> {
    const epDevPListApplicationDomainsResponse: IEpDevPListApplicationDomainsResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPApplicationDomainsApiPathsFactory.createListCachedApplicationDomainsPath({ 
        organizationId: organizationId,
        documentTypes: documentTypes
      }))
    });
    return epDevPListApplicationDomainsResponse;
  }

  public async getApplicationDomainById({ organizationId, applicationDomainId, add2CacheId }:{
    organizationId: string;
    applicationDomainId: string;
    add2CacheId?: string;
  }): Promise<IEpDevPApplicationDomain> {
    const epDevPApplicationDomain: IEpDevPApplicationDomain = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPApplicationDomainsApiPathsFactory.createByIdPath({ 
        organizationId: organizationId, 
        applicationDomainId: applicationDomainId, 
        add2CacheId: add2CacheId, 
      }))
    });
    return epDevPApplicationDomain;    
  }

  public async createApplicationDomainsCache({ organizationId }: {
    organizationId: string;
  }): Promise<string> {
    const cacheId: string = await this.request({
      method: 'POST',
      url: await this.createUrl(EpDevPApplicationDomainsApiPathsFactory.createCacheCreatePath({ 
        organizationId: organizationId,
      }))
    });
    return cacheId;
  }

  public async replaceApplicationDomainsCache({ organizationId, sourceCacheId, organizationDocumentType }:{
    organizationId: string;
    sourceCacheId: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): Promise<void> {
    const xvoid: void = await this.request({
      method: 'PUT',
      url: await this.createUrl(EpDevPApplicationDomainsApiPathsFactory.createCacheReplacePath({ 
        organizationId: organizationId,
        sourceCacheId: sourceCacheId,
        organizationDocumentType: organizationDocumentType
      }))
    });
    xvoid;
  }

  public async clearApplicationDomainsCache({ organizationId, tempCacheId, organizationDocumentType }:{
    organizationId: string;
    tempCacheId?: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): Promise<void> {
    const xvoid: void = await this.request({
      method: 'DELETE',
      url: await this.createUrl(EpDevPApplicationDomainsApiPathsFactory.createCacheDeletePath({ 
        organizationId: organizationId,
        tempCacheId: tempCacheId,
        organizationDocumentType: organizationDocumentType
      }))
    });
    xvoid;
  }

}
